import { Trans, useTranslation } from 'react-i18next';
import { useTeamContext } from '../../../Team.context';
import { Button } from 'react-daisyui';
import { useWorkspaceContext } from '../../../../../../../providers/WorkspaceProvider/Workspace.context';
import Select from 'react-select';

export default function DeleteUserForm() {
  const { t } = useTranslation('settings/team');

  const { workspaceInfo } = useWorkspaceContext();
  const { toggleDeleteModal, userToDelete, deleteUserFormik, deletingUser } =
    useTeamContext();

  const availableUsers = Object.values(workspaceInfo?.users ?? {})
    .filter((user) => user.authId !== userToDelete?.authId)
    .map((user) => ({
      value: user.authId,
      label: user.name,
    }));

  return (
    <form
      onSubmit={deleteUserFormik?.handleSubmit}
      noValidate
      className="TeamSection__Modal__Form"
    >
      <div className="DeleteUserModal__Considerations">
        <p className="DeleteUserModal__Considerations__Title">
          {t('page.form.label.modal-delete-user.considerations')}
        </p>
        <div className="DeleteUserModal__Considerations__List">
          <p className="DeleteUserModal__Considerations__Item">
            <Trans
              i18nKey={'settings/team:page.form.label.modal-delete-user.note1'}
              values={{
                name: userToDelete?.name,
              }}
            />
            <Select
              options={availableUsers}
              id="newRecipientUser"
              name="newRecipientUser"
              value={deleteUserFormik?.values.newRecipientUser}
              onChange={(value) =>
                deleteUserFormik?.setFieldValue('newRecipientUser', value)
              }
              onBlur={deleteUserFormik?.handleBlur}
              className="mt-2"
              menuPlacement="top"
              maxMenuHeight={200}
            />
          </p>
          {deleteUserFormik?.touched.newRecipientUser &&
          deleteUserFormik.errors.newRecipientUser ? (
            <div className="ProfileForm__errorMessage">
              {deleteUserFormik?.errors.newRecipientUser.value}
            </div>
          ) : null}
          <p className="DeleteUserModal__Considerations__Item">
            <Trans
              i18nKey={'settings/team:page.form.label.modal-delete-user.note'}
              values={{
                name: userToDelete?.name,
              }}
              components={{ span: <span className="font-bold"></span> }}
            />
          </p>
        </div>
      </div>
      <div className="DeleteUserModal__Buttons ">
        <Button
          className="ProfileForm__submitButton"
          size="md"
          color="neutral"
          onClick={() => toggleDeleteModal(false)}
        >
          {t('page.form.button.cancel.text')}
        </Button>
        <Button
          type="submit"
          className="ProfileForm__submitButton"
          size="md"
          color="error"
          loading={deletingUser}
        >
          {t('page.form.button.delete-member.text')}
        </Button>
      </div>
    </form>
  );
}
